import { Card as UiCard, CardContent as UiCardContent } from '@/components/ui/card'
import { cn } from '@/lib/utils'

import {
  cardContentVariants,
  cardVariants,
  type CardContentVariants,
  type CardVariants,
} from '../../configs/card.config'

import type { ComponentProps } from 'react'

export function Card({ className, variant, spacing, ...props }: ComponentProps<typeof UiCard> & CardVariants) {
  return <UiCard className={cn(cardVariants({ variant, spacing }), className)} {...props} />
}

export function CardContent({
  className,
  padding,
  ...props
}: ComponentProps<typeof UiCardContent> & CardContentVariants) {
  return <UiCardContent className={cn(cardContentVariants({ padding }), className)} {...props} />
}
